<div class="flex flex-col gap-5">
    <!-- Header -->
    <div class="flex flex-row justify-between items-center">
        <h5 [@first] class="text-zen font-medium text-3xl">
            {{ "txt_job_grade" | translate: language:ModuleNames.Common }}
        </h5>
        <button class="btn exp uppercase leading-12 rounded px-5" (click)="onAddJobGrade()">
            {{ "btn_add_job_grade" | translate: language:ModuleNames.Common }}
        </button>
    </div>

    <!-- Table -->
    <div class="my-8 py-5">
        <t-table *ngIf="selectedEntity?.JobGrades" [options]="jobOptions">
            <ng-template #cellTempate let-element let-column="column" let-colIndex="colIndex">
                <!-- Name Column -->
                <ng-container *ngIf="column.field == 'first'; else second">
                    <h5 class="max-w-xs truncate text-sm text-zen leading-20">
                        {{ extractNameLanguage(element?.name) }}
                    </h5>
                </ng-container>

                <!-- Band Level Column -->
                <ng-template #second>
                    <ng-container *ngIf="column.field == 'second'; else options">
                        <h5 class="max-w-xs truncate text-sm text-zen leading-20">
                            {{ extractBandLevelName(element.bandLevelKey) || "NA" }}
                        </h5>
                    </ng-container>
                </ng-template>

                <!-- Options Menu -->
                <ng-template #options>
                    <ng-container *ngIf="column.field == 'options'">
                        <div class="flex flex-row justify-end items-center gap-2 h-full">
                            <i [ZMenuTriggerFor]="menu"
                                class="fal font-normal fa-ellipsis-h h-9 w-9 leading-9 bg-white text-zen rounded-full btn text-center"></i>
                            <z-menu #menu>
                                <menuItems>
                                    <a MenuItem (click)="onEditJobGrade(colIndex, element)">
                                        <i class="fal fa-pen mx-1"></i>
                                        {{ "btn_leaver_list_edit" | translate: language:ModuleNames.Common }}
                                    </a>
                                    <a MenuItem delete (click)="onDeleteJobGrade(colIndex, element)">
                                        <i class="fal fa-trash mx-1"></i>
                                        {{ "btn_leaver_list_delete" | translate: language:ModuleNames.Common }}
                                    </a>
                                </menuItems>
                            </z-menu>
                        </div>
                    </ng-container>
                </ng-template>
            </ng-template>
        </t-table>

        <!-- Empty State -->
        <EmptySection *ngIf="selectedEntity?.JobGrades && selectedEntity?.JobGrades.length == 0">
        </EmptySection>
    </div>
</div>